import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "requisites-group" }
const _hoisted_2 = { colspan: "9" }
const _hoisted_3 = { class: "requisites-group__head" }
const _hoisted_4 = ["title"]
const _hoisted_5 = ["checked", "indeterminate", "title"]
const _hoisted_6 = {
  key: 0,
  class: "requisites-group__more"
}
const _hoisted_7 = { class: "card-info__title" }
const _hoisted_8 = { class: "card-info__number d-flex align-items-start gap-1 flex-wrap" }
const _hoisted_9 = { class: "card-info__name" }
const _hoisted_10 = { class: "requisites-group__count" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PayMethodIcon = _resolveComponent("PayMethodIcon")!
  const _component_copy_button = _resolveComponent("copy-button")!

  return (_openBlock(), _createElementBlock("tr", _hoisted_1, [
    _createElementVNode("td", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass(["requisites-group__chevron", {'requisites-group__chevron--open': _ctx.expanded}]),
          title: _ctx.expanded ? _ctx.$t('requisites.group_collapse') : _ctx.$t('requisites.group_expand'),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('toggleExpand')))
        }, _cache[5] || (_cache[5] = [
          _createElementVNode("svg", {
            width: "20",
            height: "20",
            viewBox: "0 0 20 20",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
          }, [
            _createElementVNode("path", {
              d: "M6 8L10 12L14 8",
              stroke: "currentColor",
              "stroke-width": "1.5",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            })
          ], -1)
        ]), 10, _hoisted_4),
        _createElementVNode("input", {
          type: "checkbox",
          class: "form-check-input flex-shrink-0",
          checked: _ctx.isAllSelected,
          indeterminate: _ctx.isPartiallySelected,
          title: _ctx.$t('requisites.group_select_all'),
          onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('select', $event.target.checked)))
        }, null, 40, _hoisted_5),
        _createElementVNode("div", {
          class: "requisites-group__icons",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('toggleExpand')))
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleMethods, (method) => {
            return (_openBlock(), _createBlock(_component_PayMethodIcon, {
              key: method,
              "icon-class": "pay-method-icon-xl",
              method: method
            }, null, 8, ["method"]))
          }), 128)),
          (_ctx.hiddenMethodsCount > 0)
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, "+" + _toDisplayString(_ctx.hiddenMethodsCount), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", {
          class: "requisites-group__main",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('toggleExpand')))
        }, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("span", null, [
              _createElementVNode("strong", null, _toDisplayString(_ctx.currencies.join(', ')), 1),
              _createTextVNode(" " + _toDisplayString(_ctx.paymentOptions.join(', ')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("span", null, _toDisplayString(_ctx.phone), 1),
            _createVNode(_component_copy_button, {
              value: _ctx.phone,
              class: "flex-shrink-0 align-self-center",
              onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
            }, null, 8, ["value"])
          ]),
          _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.holderName), 1)
        ]),
        _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.helper.trans('requisites.group_active_count', {active: _ctx.activeCount, total: _ctx.group.items.length})), 1)
      ])
    ])
  ]))
}